import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, Smartphone, Clock, Brain } from 'lucide-react';
export function ProblemSection() {
  const spiralSteps = [{
    icon: Clock,
    text: 'Miro la hora y calculo cuánto falta para levantarme'
  }, {
    icon: AlertCircle,
    text: "Me enojo porque 'otra vez me pasó'"
  }, {
    icon: Brain,
    text: 'Pienso en todo lo que tengo que hacer mañana'
  }, {
    icon: Smartphone,
    text: 'Agarro el celular para distraerme (error fatal)'
  }, {
    icon: AlertCircle,
    text: 'Me acelero y perdí una hora de sueño'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white text-navy" data-id="element-127">
      <div className="max-w-5xl mx-auto" data-id="element-128">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-129">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-130">
            <h2 className="text-3xl sm:text-4xl font-bold mb-6 font-serif text-navy" data-id="element-131">
              La trampa: tratar el despertar 3AM como si fuera "dormirse"
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-132">
              La mayoría de consejos se enfocan en el inicio del sueño:
              "Rutina", "té", "respirar", "meditar", "no pantallas".
            </p>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed font-medium" data-id="element-133">
              Pero tu dolor real es otro:{' '}
              <span className="text-purple" data-id="element-134">
                vos te dormís… y después te despertás.
              </span>
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-135">
              Y cuando te despertás, tu cuerpo ya está activado. Ahí es donde
              fallan las soluciones viejas: no te dicen qué hacer{' '}
              <strong data-id="element-136">cuando ya estás despierta</strong>.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-cream rounded-3xl p-8 shadow-lg border border-purple/10" data-id="element-137">
            <h3 className="text-xl font-bold mb-6 text-center text-purple font-serif" data-id="element-138">
              La Espiral de las 3AM
            </h3>
            <div className="space-y-4 relative" data-id="element-139">
              {/* Vertical line connecting steps */}
              <div className="absolute left-6 top-4 bottom-4 w-0.5 bg-purple/20" data-id="element-140"></div>

              {spiralSteps.map((step, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: 0.3 + index * 0.1
            }} className="relative flex items-center bg-white p-4 rounded-xl shadow-sm border border-gray-100 z-10" data-id="element-141">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-purple/10 flex items-center justify-center text-purple mr-4" data-id="element-142">
                    <step.icon className="w-6 h-6" data-id="element-143" />
                  </div>
                  <p className="text-gray-700 font-medium" data-id="element-144">{step.text}</p>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}